import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import { useSelector } from "react-redux";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import { Endpoints } from '../../Global/Endpoints';
import { toast } from "react-toastify";
import { setFullyVerified } from '../../Redux/verificationReducer';
import { updateEmail } from '../../Redux/emailReducer';
import { updateUserData } from '../../Redux/userReducer';
import { setPartiallyVerified } from '../../Redux/verificationReducer';
import { useDispatch } from 'react-redux';
import ErrorModal from "../../Components/Security/ErrorModal";
import { de } from '@faker-js/faker';
import { set } from 'date-fns';


const PatientConsentForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
  const [logo, setLogo] = useState(null);
const location = useLocation();
 const fromLogin = useSelector(state => state.fromLogin.fromLogin);
const { updatedFormData, responseData, otherData } = location.state || {};
  const [loading, setLoading] = useState(false);
  const isUKDTC = updatedFormData?.Country === "United Kingdom" && updatedFormData.BenefitProvider === "I'm paying for myself";
  // Only these three required, rest are optional
  const [consentData, setConsentData] = useState({
    dataProcessingConsent: false, // required
    dataTransferConsent: false,   // required
    providerInfoConsent: false,   // required
    recordingConsent: false,
    ageVerificationConsent: false,
    rightsAcknowledgement: false,
    hipaaDisclosureConsent: false,
    partnerConsent: false,
    consentAll: false,
  });

  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);

  useEffect(() => {
    if(location.state?.otherData?.consentData){
      setConsentData(location.state?.otherData.consentData);
    }
  }, [location.state?.otherData]);

  useEffect(() => {
    if (location.state?.isNavigatingFromCompany) {
      blockOnBackNavigation();
    }
  }, [location.state?.isNavigatingFromCompany]);

const blockOnBackNavigation = () => {
  const handlePopState = () => {
    window.history.pushState(null, "", window.location.href);
  };

  window.history.pushState(null, "", window.location.href);
  window.addEventListener("popstate", handlePopState);

  // Return cleanup
  return () => {
    window.removeEventListener("popstate", handlePopState);
  };
};

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
      new window.bootstrap.Carousel(myCarousel, {
        interval: 5000,
      });
    }
  }, []);

  const handleConsentAllChange = () => {
    const newValue = !consentData.consentAll;
    setConsentData({
      dataProcessingConsent: newValue,
      dataTransferConsent: newValue,
      providerInfoConsent: newValue,
      recordingConsent: newValue,
      ageVerificationConsent: newValue,
      rightsAcknowledgement: newValue,
      hipaaDisclosureConsent: newValue,
      partnerConsent: newValue,
      consentAll: newValue,
    });
    setErrorMessage('');
  };

  const handleCheckboxChange = (field) => {
    setConsentData(prev => ({
      ...prev,
      [field]: !prev[field],
      consentAll: false,
    }));
    setErrorMessage('');
  };

 const handleNext = async () => {
  const requiredConsents = [
    'dataProcessingConsent',
    'dataTransferConsent',
    'providerInfoConsent'
  ];
  const allRequiredGiven = requiredConsents.every(consent => consentData[consent]);
  if (!allRequiredGiven) {
    setErrorMessage('Please provide consent to all required items marked with (*) to continue.');
    return;
  }
  let formattedDOB = "";
  if (updatedFormData?.DOB) {
    const date = new Date(updatedFormData.DOB);
    if (!isNaN(date.getTime())) {
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const yyyy = date.getFullYear();
      formattedDOB = `${yyyy}-${mm}-${dd}`;
    }
  }
  const payload = {
    PrintName: updatedFormData.PreferredName,
    Store_data: consentData.dataProcessingConsent ? "Yes" : "No",
    Call_recordings: consentData.recordingConsent ? "Yes" : "No",
    Store_data_us: consentData.dataTransferConsent ? "Yes" : "No",
    Age_verification: consentData.ageVerificationConsent ? "Yes" : "No",
    Understand_rights: consentData.rightsAcknowledgement ? "Yes" : "No",
    Win_contact: consentData.providerInfoConsent ? "Yes" : "No",
    Hipaa_consent: consentData.hipaaDisclosureConsent ? "Yes" : "No",
    Eaap_consent: consentData.partnerConsent ? "Yes" : "No",
    First_Name: updatedFormData.FirstName,
    Last_Name: updatedFormData.LastName,
    Address:  "",
    City: updatedFormData.City || "",
    Postal: updatedFormData.ZipCode,
    Country: updatedFormData.Country,
    DOB: formattedDOB,
    Cell_Phone: updatedFormData.PhoneNo,
    Personal_Email: updatedFormData.EmailID,
    Contract: isUKDTC ? "WINFertilityUKDTC" : responseData?.ContractIdentified || "",
    MemberID: responseData?.MemberID || ""
  };
setLoading(true);
  try {
    setErrorMessage("");
   const response = await axios.post(
  Endpoints.SaveConsentQuestions, // Your endpoint
  null,                          // No body, since using query param
  {
    params: { _Params: JSON.stringify(payload) },
  }
);
console.log("Consent Save Response:", response);
if(response.data === "Details Saved Sucessfully") {
    // Redirect with state
                      if (fromLogin) {
                         dispatch(setPartiallyVerified());
                      const token=localStorage.getItem('AccessToken');
                      if(token)
                      {
                          const expirationTime = Date.now() + 15 * 60 * 1000; // 15 minutes
                          localStorage.setItem('sessionExpiration', expirationTime.toString());
                           localStorage.removeItem('sessionExpired'); // Clear any existing expired flag
                                                        
                                                        // Update Redux state
                            dispatch({ type: 'LOGIN_SUCCESS', payload: token });
                           dispatch(setFullyVerified());
                             dispatch(updateUserData(response.data));
                            dispatch(updateEmail(updatedFormData.EmailID));     
                               toast.success(t('profilesavedsucessfully'), { autoClose: 3000 });                                               
                        navigate('/home')
                      }
                    }
                    else{
      const mergedFormData = { 
                          ...updatedFormData, 
                          BabyCountFlag: response.data.BabyCountFlag 
                        };
                        if(isUKDTC){
                          navigate('/referral-source', {
                            state: {
                              updatedProviderData: mergedFormData,
                              otherData: {
                                ...otherData,
                                consentData,
                                updatedProviderData: mergedFormData // <-- add here for robust state passing
                              }
                            }
                          });
                        }else{
    navigate("/healthprofilesetup", { state: {updatedFormData:mergedFormData} });
                        }
dispatch(setPartiallyVerified());
                    }
                  } else {
    setModalMessage(response.data.ResultText || "Failed to save consent. Please try again.");
    setShowModal(true);
  
  }
 } catch (error) {
    setErrorMessage("Failed to save consent. Please try again.");
  } finally {
    setLoading(false);
  }
};

 
  const handleBackClick = () => {
    if(location.state?.isNavigatingFromCompany){
      blockOnBackNavigation();
  }else if(otherData.navigatingFromBenefitOptions){
    const combinedFormData = updatedFormData
    navigate('/benefit-options',{state:{combinedFormData, otherData:{...otherData,consentData:consentData} }}); // Redirects to the home page
  }else{
    navigate(-1);
  }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
  
  return (
    <>
      {/* Header */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
            {logo && (
              <img src={logo} alt="Logo" className="logo brand-logo" />
            )}
          </a>
        </nav>
      </header>

      <div className="registration-block-main patient-consent-screen">
        {/* Left carousel start */}
        <div className="registration-image-wrapper">

            <h3 className="page-heading-secondary-black">PATIENT CONSENT FORM</h3>
          {isUKDTC ?
            <>
              <p>
                WIN is pleased to offer services to you. To proceed, we are required to obtain your consent in accordance with program requirements and applicable privacy regulations.</p>
              <p>
                Please review and respond to the consent questions below. Kindly note that if you choose not to provide consent, or if you withdraw your consent at a later time, WIN’s ability to deliver some or all of the services may be limited.</p>
            </>
            :
            <>
              <p>
                To proceed, we are required to obtain your consent in accordance with program requirements and applicable privacy regulations.
              </p>
              <p>
                Please review and respond to the consent questions below. Kindly note that if you choose not to provide consent, or if you withdraw your consent at a later time.
              </p>
            </>
          }
          <p>
            If you have any questions or need assistance, please don’t hesitate to contact us. We look forward to supporting you throughout your journey.
          </p>
            <p>
              You can click on <a 
                href="https://www.winfertility.com/privacy-policy/"
                className="text-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy policy
              </a>
              to get more information on:
              
              <ol>
                <li>What personal information WIN obtains, stores and processes, and why</li>
                <li>How WIN will use your personal information</li>
                <li>Where your personal information is stored and processed</li>
                <li>Who WIN will share your personal information with</li>
                <li>Confidentiality and the security of your personal information</li>
                <li>How you can access your information that is stored with us</li>
                <li>Your rights with respect to your personal information</li>
              </ol>
            </p>

        </div>
        {/* Left carousel end */}

        {/* Registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form">

            

            <div className="registration-process-form-wrapper mt-5">
              <form>

                <h4 className="page-heading-secondary-black">Data and Information Consent</h4>

                {/* Required Consent 1 */}
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mt-3"
                    checked={consentData.dataProcessingConsent}
                    onChange={() => handleCheckboxChange('dataProcessingConsent')}
                  />
                  <label className="multistep-form-radio-checkbox-label text-primary-color">
                    Do you provide consent to WINFertility to obtain, store, process and share your personal information to the extent necessary to provide services to you? 
                  </label>
                </div>
                {/* Optional Consents (Default color) */}
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mt-3"
                    checked={consentData.recordingConsent}
                    onChange={() => handleCheckboxChange('recordingConsent')}
                  />
                  <label className="multistep-form-radio-checkbox-label">
                    Your conversations with WINFertility may be recorded for quality assurance purposes. Do you provide consent for storage and archival of these call recordings by WINFertility?
                  </label>
                </div>
                {/* Required Consent 2 */}
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mt-3"
                    checked={consentData.dataTransferConsent}
                    onChange={() => handleCheckboxChange('dataTransferConsent')}
                  />
                  <label className="multistep-form-radio-checkbox-label text-primary-color">
                    Do you provide consent for transfer of your personal data from your current country to WINFertility’s data centers located in the United States?
                  </label>
                </div>          

                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mt-3"
                    checked={consentData.ageVerificationConsent}
                    onChange={() => handleCheckboxChange('ageVerificationConsent')}
                  />
                  <label className="multistep-form-radio-checkbox-label">
                    WINFertility will require verification of your age during its interactions with you for security and compliance purposes. Do you provide consent for such verification?
                  </label>
                </div>

                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mt-3"
                    checked={consentData.rightsAcknowledgement}
                    onChange={() => handleCheckboxChange('rightsAcknowledgement')}
                  />
                  <label className="multistep-form-radio-checkbox-label">
                    In relation to your personal information stored with us, you have the right to access, obtain a copy, rectify, erase, restrict, withdraw consent, or report to a Supervisory Authority. A link to our privacy policy will be sent to you further explaining these rights. Do you confirm your understanding of these rights?
                  </label>
                </div>

                  {/* Required Consent 3 */}
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mt-3"
                    checked={consentData.providerInfoConsent}
                    onChange={() => handleCheckboxChange('providerInfoConsent')}
                  />
                  <label className="multistep-form-radio-checkbox-label text-primary-color">
                    You acknowledge that WIN needs to contact your physician, pharmacy or employer’s human resources department to obtain the necessary medical, pharmacy and benefit information to assist you in the program.
                  </label>
                </div>
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mt-3"
                    checked={consentData.hipaaDisclosureConsent}
                    onChange={() => handleCheckboxChange('hipaaDisclosureConsent')}
                  />
                  <label className="multistep-form-radio-checkbox-label">
                    You acknowledge that WIN will send you an e-mail copy of your acknowledgements and consents, which act as your HIPAA disclosure consent form, if you reside in the United States. You may contact WIN at any time to change, restrict or terminate your HIPAA consents.
                  </label>
                </div>

                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input mt-3"
                    checked={consentData.partnerConsent}
                    onChange={() => handleCheckboxChange('partnerConsent')}
                  />
                  <label className="multistep-form-radio-checkbox-label">
                    You acknowledge that WIN partners with the Employee Adoption & ART program (EAAP) for adoption and surrogacy support. Should you wish to consult with or have access to that program, your information will be shared with the EAAP for services.
                  </label>
                </div>

                {/* Consent All */}
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input radio-btn win-form-check-input"
                    checked={consentData.consentAll}
                    onChange={handleConsentAllChange}
                  />
                  <label className="multistep-form-radio-checkbox-label">
                    I give consent to all the above
                  </label>
                </div>

                {/* Consent instructions */}
                <div className="form-text text-center mt-2" style={{ color: '#E4007C', fontWeight: 500 }}>
                  *If you do not wish to consent to any of the above, please contact WINFertility.
                </div>

                {/* Error Message */}
                {errorMessage && (
                  <div className="form-field-error-message">{errorMessage}</div>
                )}

                {/* Navigation Buttons */}
                <div className="mt-5">
                     <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0"  onClick={handleBackClick}>{t('back')}</button>
                  <button
                    type="button"
                    className="win-btn-primary mobile-view"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Registration right form area end */}
        <ErrorModal
          show={showModal}
          message={modalMessage}
          onClose={() => setShowModal(false)}
        />
      </div>
    </>
  );
};

export default PatientConsentForm;
